import type { CreateClientConfig } from '../generated/uis/client.gen';
import {
  createFetchWithTimeout,
  ENDPOINT_UIS_API,
  ENDPOINT_UIS_API_KEY,
  ENDPOINT_UIS_API_TIMEOUT,
} from '../utils';

export const createClientConfig: CreateClientConfig = config => ({
  ...config,
  baseUrl: ENDPOINT_UIS_API,
  headers: {
    'x-api-key': ENDPOINT_UIS_API_KEY,
  },
  fetch: createFetchWithTimeout(ENDPOINT_UIS_API_TIMEOUT),
});
